import React from 'react';
import cn from 'classnames';
import { useEditorContainerSize } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import EditorDeviationLink from '../_partials/DeviationLink';
import { useFreeformSquareSizing } from '../helpers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Timestamp from '../../../Timestamp';
import s from './Poll.scss';
const MAX_QUESTION_LENGTH = 55;
const PollMonoView = (props)=>{
    const containerSize = useEditorContainerSize();
    const { deviation, extOptions, width: propsWidth, link } = props;
    const { width, height } = useFreeformSquareSizing(propsWidth, extOptions, containerSize);
    const { poll } = deviation;
    const questionTruncated = (poll === null || poll === void 0 ? void 0 : poll.question) && poll.question.length > MAX_QUESTION_LENGTH ? `${poll.question.slice(0, MAX_QUESTION_LENGTH)}...` : poll === null || poll === void 0 ? void 0 : poll.question;
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root']),
        style: {
            width,
            height
        }
    }, /*#__PURE__*/ React.createElement(EditorDeviationLink, {
        link: link,
        deviation: deviation
    }, /*#__PURE__*/ React.createElement(Section, null, /*#__PURE__*/ React.createElement(Heading, {
        className: s['question']
    }, questionTruncated), /*#__PURE__*/ React.createElement("div", {
        className: s['info']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['date']
    }, /*#__PURE__*/ React.createElement(Timestamp, {
        timestamp: poll === null || poll === void 0 ? void 0 : poll.ts
    })), "  |  ", /*#__PURE__*/ React.createElement("span", {
        className: s['vote-count']
    }, poll === null || poll === void 0 ? void 0 : poll.votes, " votes")))));
};
PollMonoView.displayName = 'PollMonoView';
export default PollMonoView;

//# sourceMappingURL=Poll.js.map